// FILE: _chat.snoozed.tsx
// Purpose: Registers the Pospuestos section under the shared chat shell.
// Layer: Route
// Exports: Route

import { createFileRoute } from "@tanstack/react-router";
import { SnoozedThreadsView } from "~/components/snoozed/SnoozedThreadsView";

// No search params: the list is everything this person has put aside, and there
// is nothing to filter it by that the sidebar does not already answer.
export const Route = createFileRoute("/_chat/snoozed")({
  component: SnoozedThreadsView,
});
